import React, { useEffect, useState, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";

import { useLazyQuery } from "@apollo/client";
import Search from "@material-ui/icons/Search";
import queryString from "query-string";

import { SEARCH_ASSET_GLOBAL } from "./quey";

export function GlobalMasterSearch({ type = "text", label, ...props }) {
  let location = useLocation();
  let history = useHistory();

  const [globalData, setSearchData] = useState([]);

  const inputRef = useRef();

  const equipmentSearch = () => {
    const val = inputRef.current.value;

    if (val) {
      history.push(`/search?q=${val}`);
    }
  };

  const [
    searchGlobalData,
    { loading: searchLoading, data: searchData },
  ] = useLazyQuery(SEARCH_ASSET_GLOBAL, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (location?.search) {
      const searchValue = queryString.parse(location?.search);

      inputRef.current.value = searchValue.q;
    } else {
      inputRef.current.value = "";
    }
  }, [location]);

  useEffect(() => {
    if (searchData) {
      if (inputRef?.current?.value) {
        setSearchData(searchData.masterSearch);
      } else {
        setSearchData([]);
      }
    }
  }, [searchLoading, searchData]);

  const searchBy = async ev => {
    searchGlobalData({
      variables: {
        search: ev.target.value,
      },
    });
  };

  return (
    <>
      {label && <label>Enter {label}</label>}
      <div className="globalMasterSearch">
        <input
          {...props}
          placeholder="Search here"
          autoComplete="off"
          list="searchlist"
          type="text"
          onChange={e => searchBy(e)}
          onKeyPress={event => {
            if (event.key === "Enter") {
              equipmentSearch();
            }
          }}
          name="search"
          ref={inputRef}
        />
        <Search className="searchIconHeader" onClick={equipmentSearch} />
        {searchLoading ? (
          <span className="ml-2 spinner"></span>
        ) : (
          <datalist id="searchlist">
            {globalData.length > 0 &&
              globalData.map(o => (
                <option
                  key={`global-search-${o.id}`}
                  value={`${o.make.name} ${o.model.name} ${o.category.name}`}
                >{`${o.make.name} ${o.model.name} ${o.category.name}`}</option>
              ))}
          </datalist>
        )}
      </div>
    </>
  );
}
